// sales-flow-v3
import { useCallback, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { PageHeader } from "@/components/PageHeader";
import { ClientFlowBar, stepOf } from "@/components/ClientFlowBar";
import { PipelinePage } from "@/pages/revenue/PipelinePage";
import LeadsBoard from "@/components/sales/LeadsBoard";
import { cfg as proposalsCfg } from "@/pages/revenue/Proposals";
import { cfg as contractsCfg } from "@/pages/revenue/Contracts";

const CFG = { proposals: proposalsCfg, contracts: contractsCfg };
const TITLE = {
  capture: "Your leads board. Drag a card between stages, or open a lead to log calls and set follow-ups.",
  qualify: "Your leads board. Open a qualified lead and click Next: Make proposal to start the priced quotation.",
  sent: "Proposals to send, and sent ones waiting for the design review.",
  review: "Design review done (changes asked or approved). Book the PO once it is approved.",
  po: "Client POs booked as contracts.",
  convert: "Contracts with no project yet. Click Next: Create project.",
  closed: "Leads that were won or lost.",
};

/** One page for the whole sales flow: Lead Capture -> Qualify -> Proposal Sent -> Design Review -> PO Won -> Convert to Project. */
export default function SalesFlow() {
  const [params, setParams] = useSearchParams();
  const step = stepOf(params.get("step") || "capture");
  const [ver, setVer] = useState(0);
  const bump = useCallback(() => setVer((v) => v + 1), []);
  return (
    <div className="space-y-5" data-testid="sales-flow-page">
      <PageHeader title="Sales Flow" description={TITLE[step.key]} />
      <ClientFlowBar active={step.key} version={ver} onSelect={(k) => setParams({ step: k }, { replace: true })} />
      {step.from === "leads"
        ? <LeadsBoard key={step.key} closed={step.key === "closed"} onChanged={bump} />
        : <PipelinePage key={step.key} cfg={CFG[step.from]} embedded rowFilter={step.test} onLoaded={bump} />}
    </div>
  );
}
